import React from 'react';

import Button from '../Buttons/Button/Button';
import scrollTo from '../../helpers/scrollTo';

export enum navLayouts {
    row = 'ROW',
    column = 'COLUMN'
}

interface props {
    layout?: navLayouts,
    callback?: ()=> void
}

const MainNav = ({ layout, callback }: props): JSX.Element => {
    const handleScrollToProducts = (e: React.MouseEvent) => {
        e.preventDefault();
        scrollTo('#our-products');

        if (typeof callback === 'function') {
            callback();
        }
    };

    const handleScrollToPricing = (e: React.MouseEvent) => {
        e.preventDefault();
        scrollTo('#pricing');

        if (typeof callback === 'function') {
            callback();
        }
    };

    const handleScrollToClients = (e: React.MouseEvent) => {
        e.preventDefault();
        scrollTo('#clients');

        if (typeof callback === 'function') {
            callback();
        }
    };

    const layoutClassName = layout === navLayouts.column ? 'flex-col' : 'flex-row';

    return (
        <nav className={`flex items-center gap-3 ${layoutClassName}`}>
            <a className="p-3" href="#our-products" onClick={handleScrollToProducts} title="View our products">Our products</a>
            <a className="p-3" href="#pricing" onClick={handleScrollToPricing} title="View our prices">Pricing</a>
            <a className="p-3" href="#clients" onClick={handleScrollToClients} title="View our clients">Clients</a>
            <a className="p-3" href="https://changemyface.medium.com/" rel="noreferrer" target="_blank" title="View our latest news">News</a>
            <a className="p-3" href="https://age-and-lifestyle.changemyface.com" rel="nofollow" title="Demo">Demo</a>
            <Button title="Get started by contacting us" onClick={handleScrollToPricing}>
                Get started
            </Button>
        </nav>
    );
};

MainNav.defaultProps = {
    layout: navLayouts.row
};

export default MainNav;
